//función que convierte la fecha de creación de la acción en formato nombre día, número de día dd, nombre mes,
//número de año completo.

function dateAction(seedDate) {
    var d = new Date(seedDate);
    var numberDay = d.getDay();
    var numberMonth = d.getMonth();
    var nameDay = ''
    var nameMonth = ''

if(numberDay === 0){nameDay = "Domingo"}
if(numberDay === 1){nameDay = "Lunes"}
if(numberDay === 2){nameDay = "Martes"}
if(numberDay === 3){nameDay = "Miércoles"}
if(numberDay === 4){nameDay = "Jueves"}
if(numberDay === 5){nameDay = "Viernes"}
if(numberDay === 6){nameDay = "Sábado"}

if(numberMonth === 0){nameMonth = "Enero"}
if(numberMonth === 1){nameMonth = "Febrero"}
if(numberMonth === 2){nameMonth = "Marzo"}
if(numberMonth === 3){nameMonth = "Abril"}
if(numberMonth === 4){nameMonth = "Mayo"}
if(numberMonth === 5){nameMonth = "Junio"}
if(numberMonth === 6){nameMonth = "Julio"}
if(numberMonth === 7){nameMonth = "Agosto"}
if(numberMonth === 8){nameMonth = "Septiembre"}
if(numberMonth === 9){nameMonth = "Octubre"}
if(numberMonth === 10){nameMonth = "Noviembre"}
if(numberMonth === 11){nameMonth = "Diciembre"}

    
 return nameDay + ' ' + d.getDate() + ' ' + 'de ' + nameMonth + ', ' + d.getFullYear() + '.'
    
  } 

  export default dateAction